<div class="card">
  <div class="card-body">
    <div class="row mt-3">
      <div class="col-4">
        <strong>PATIENT</strong>
        <app-patient-name [patient]="inboundFax.patient" [canViewPatient]="true" />
      </div>
      <div class="col-4">
        <strong>PRESCRIBER</strong>
        <app-prescriber-name [provider]="inboundFax.provider" [linkToProvider]="true" />
      </div>
      <div class="col-4">
        <strong>OUTBOUND FAX</strong>
        <div>
          @if (inboundFax.outboundFax) {
            <div> {{ inboundFax.outboundFax.createdAt | date: 'MM/dd/yyyy' }} </div>
            @if (inboundFax.outboundFax.office) {
              <app-office [office]="inboundFax.outboundFax.office" />
            }
            @if (inboundFax.outboundFax.providerOfficeStatus) {
              <div
                title="{{ keyedProviderOfficeStatusOptions[inboundFax.outboundFax.providerOfficeStatus]?.display }}">
                ({{ inboundFax.outboundFax.providerOfficeStatus }})
              </div>
            }
          } @else {
            <app-blank-value-dash />
          }
        </div>
      </div>
      @if (inboundFax.communicationMethod) {
        <div class="mt-3">
          <strong>COMMUNICATION METHOD</strong>
          <div>
            {{ inboundFax.communicationMethod }}
          </div>
        </div>
      }
      <div class="mt-3">
        @if (inboundFax.statusReason) {
          <div>
            <strong>REASON</strong>
            <div>
              {{ keyedReasonOptions[inboundFax.statusReason].display }}
            </div>
          </div>
        }
      </div>
      <div class="mt-3">
        @if (inboundFax.duplicateInboundFax) {
          <div>
            <strong>DUPLICATE FAX</strong>
            <div>
              <a
                target="_blank"
                routerLink="/capture-admin/communications/inbound-faxes/{{ inboundFax.duplicateInboundFax.id }}"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }">
                {{ inboundFax.duplicateInboundFax.patientAttachment.displayName }} -
                {{ inboundFax.duplicateInboundFax.patientAttachment.createdAt | date: 'M/d/yyyy' }}
              </a>
            </div>
          </div>
        }
      </div>
      @if (!!inboundFax.notes) {
        <div class="mt-3">
          <strong>ADDITIONAL DETAILS</strong>
          <p class="mt-1">{{ inboundFax.notes }}</p>
        </div>
      }
      @if (inboundFax.captureCount > 0) {
        <div>
          <h5>{{ inboundFax.captureCount }} {{ inboundFax.captureCount === 1 ? 'Capture' : 'Captures' }}</h5>
          <app-inbound-fax-captures [inboundFax]="inboundFax" />
        </div>
      }
    </div>
  </div>
